import { createFileRoute, redirect } from '@tanstack/react-router';

// API Keys moved into Project Settings → Integrations (the "API Keys" card,
// co-located with the integration snippets that consume them). This path stays
// as a redirect so old links/bookmarks resolve to the new home.
export const Route = createFileRoute(
  '/_auth/_side-layout/automations_/api-keys',
)({
  beforeLoad: () => {
    throw redirect({ to: '/project-settings/integrations' });
  },
});
